import { Component, Input, OnInit } from "@angular/core";
import { EmailData, EmailTemplate } from "@shared/mail";
import { AssetDetailSectionDirective } from "../asset-section";

export interface MailConfig {
    mailAdress: string;
    mailAdressUS?: string;
    subject: string;
    body: string;
}

@Component({
    selector: "brain-asset-detail-mail",
    templateUrl: "./mail.html",
    styleUrls: ["./mail.scss"]
})
export class AssetDetailMailComponent extends AssetDetailSectionDirective implements OnInit {

  public key: string;

  @Input()
  public mailData: EmailData;

  @Input()
  public mailTemplate: EmailTemplate;

  @Input()
  public btnText: string;

  @Input()
  public image: string;

  @Input()
  public title: string;

  public ngOnInit(): void {
      this.key = this.title;
      super.ngOnInit();
  }
}
